const FAQSchemaBaseStructure = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: []
};
export default function getData(content) {
  if (content === void 0) {
    content = [];
  }
  const FAQSchemaStructure = FAQSchemaBaseStructure;
  FAQSchemaStructure.mainEntity = content.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer
    }
  }));
  return FAQSchemaStructure;
}